import { Log, UserManager, WebStorageStateStore } from 'oidc-client';

const settings = {
  authority: process.env.REACT_APP_PORTAL_IDENTITY_URI,
  client_id: 'web_client',
  redirect_uri: window.location.origin + '/signin-callback',
  automaticSilentRenew: true,
  revokeAccessTokenOnSignout: true,
  silent_redirect_uri: window.location.origin + '/silent-renew-callback',
  post_logout_redirect_uri: window.location.origin + '/logout-callback',
  response_type: 'id_token token',
  scope: 'purchases templates openid profile clientportal',
  userStore: new WebStorageStateStore({ store: localStorage}),
  monitorSession: false,
  //регистрация (смс, письмо, повторный вход) может занять больше дефолтных 15 минут,
  //а SigninCallback чистит устаревшие state до обработки ответа
  staleStateAge: 60 * 60,
};
const userManager = new UserManager(settings);

const callbackPaths = ['/signin-callback', '/silent-renew-callback', '/logout-callback'];

//запоминаем текущую страницу в state, чтобы после входа/регистрации вернуть пользователя туда же
export const signinRedirectWithReturnPath = () => {
  const { pathname, search, hash } = window.location;
  const returnPath = callbackPaths.includes(pathname) ? '/' : pathname + search + hash;
  return userManager.signinRedirect({ state: { returnPath } });
};

//пускаем только относительные пути внутри портала, чтобы не получить открытый редирект
export const getSafeReturnPath = (state) => {
  const returnPath = state && state.returnPath;
  if (typeof returnPath !== 'string' || !returnPath.startsWith('/') || returnPath.startsWith('//') || returnPath.startsWith('/\\')) {
    return '/';
  }
  return returnPath;
};

userManager.events.addSilentRenewError((error) => {
  console.log("Не удается получить токен " + error);
  userManager.signoutRedirect();
});

Log.logger = console;
Log.level = Log.INFO;

export default userManager;